import range from "lodash/range"
import { parseISO, format } from "date-fns"

import { ANY, DATE_FORMAT_CART } from "../constants/constants"

export const getPagesToRender = (currentPage, pageCount) => {
  if (pageCount <= 6) {
    return range(1, pageCount + 1)
  }
  switch (currentPage) {
    case 1:
    case 2:
      return [1, 2, 3, "...", pageCount]
    case 3:
      return [1, 2, 3, 4, "...", pageCount]
    case 4:
      return [1, 2, 3, 4, 5, "...", pageCount]
    case pageCount - 4:
      return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        pageCount,
      ]
    case pageCount - 3:
      return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        pageCount,
      ]
    case pageCount - 2:
      return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        pageCount,
      ]
    case pageCount - 1:
      return [1, "...", currentPage - 1, currentPage, pageCount]
    case pageCount:
      return [1, "...", currentPage - 1, currentPage]
    default:
      return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        pageCount,
      ]
  }
}

export const capitalizeFirstLetter = (string) => {
  if (!string) return string
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const handleFlightSelection = ({ from, to }) => {
  if (from && to) {
    const fromLabelCleaned = from.fullLabel
      .replace(/\([^)]*\)/g, "")
      .toLowerCase()
    const toLabelCleaned = to.fullLabel.replace(/\([^)]*\)/g, "").toLowerCase()

    const fromWordsArr = fromLabelCleaned
      .split(/\s+|[-/'’]+/)
      .filter((word) => /^[a-zA-Z]+$/.test(word))
    const toWordsArr = toLabelCleaned
      .split(/\s+|[-/'’]+/)
      .filter((word) => /^[a-zA-Z]+$/.test(word))

    let fromValidation = fromWordsArr.filter((word) => {
      const isAlphabetic = /^[a-zA-Z]+$/.test(word)
      return isAlphabetic && !["", " ", "-"].includes(word)
    })
    let toValidation = toWordsArr.filter((word) => {
      const isAlphabetic = /^[a-zA-Z]+$/.test(word)
      return isAlphabetic && !["", " ", "-"].includes(word)
    })

    const fromURL = fromValidation.join("-") + "-" + from.value
    const toURL = toValidation.join("-") + "-" + to.value

    return { fromURL, toURL }
  }
}

export const getCodeFromRoute = (route) => {
  const routeParts = route.split("-to-")
  if (routeParts.length === 2) {
    const [originRoute, destinationRoute] = routeParts

    const origin = originRoute.slice(-3).toLowerCase()
    const destination = destinationRoute.slice(-3).toLowerCase()

    const origin_city =
      originRoute.slice(-3).toLowerCase() === ANY.toLowerCase()
        ? originRoute.substring(0, originRoute.lastIndexOf("-"))
        : ""
    const destination_city =
      destinationRoute.slice(-3).toLowerCase() === ANY.toLowerCase()
        ? destinationRoute.substring(0, destinationRoute.lastIndexOf("-"))
        : ""

    return { origin, destination, origin_city, destination_city }
  }

  return null
}

export const generateRandomNumbers = (range) => {
  const numbers = []
  while (numbers.length < range) {
    const num = Math.floor(Math.random() * range)
    if (numbers.indexOf(num) === -1) numbers.push(num)
  }
  return numbers
}

export const formatTime = (dateStr) => {
  const utcDate = new Date(dateStr)
  const hours = String(utcDate.getUTCHours()).padStart(2, "0")
  const minutes = String(utcDate.getUTCMinutes()).padStart(2, "0")

  return `${hours}:${minutes}`
}

export const formatUTCDate = (dateStr, dateFormat) => {
  const date = parseISO(dateStr)
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000)

  return format(utcDate, dateFormat)
}

export const getDatesOptions = () => {
  const dates = [{ label: "All", value: null }]
  const currentDate = new Date()

  for (let i = 0; i < 13; i++) {
    const date = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + i,
      1
    )
    dates.push({
      value: format(date, "yyyy-MM"),
      label: format(date, "MMM yy"),
    })
  }

  return dates
}

export const formatCartDate = (dateStr) => {
  if (!dateStr) return ""

  try {
    const date = parseISO(dateStr)
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000)
    return format(utcDate, DATE_FORMAT_CART)
  } catch (error) {
    console.error("Error formatting cart date:", error)
    return dateStr
  }
}
